import { render } from "./Interest.vue?vue&type=template&id=4ea0994d"
import script from "./Interest.vue?vue&type=script&lang=js"
export * from "./Interest.vue?vue&type=script&lang=js"
script.render = render

export default script